import {cc} from "../callback-chain";
import {cs} from "../chain-services";

import {loadingSequence} from "./loading-sequence";

export const ModuleSwamp = ({moduleFeeds, next}) => cs(
    ["modules", ({}, next) => cc(
        {
            modules: [],
            nameMap: {},
        },
        [
            ...loadingSequence(moduleFeeds).map((mf) => (
                (total, next) => cc([
                    // (_, next) => fragments(
                    //     OnUnmounted({
                    //         action: () => console.log("Unmounted", seq[i-1]),
                    //     }),
                    //     next(),
                    // ),
                    (_, next) => mf.load(total.nameMap, next),
                    (module) => next({
                        modules: [...total.modules, {
                            module,
                            feed: mf,
                        }],
                        nameMap: mf.name ? {
                            ...total.nameMap,
                            [mf.name]: module,
                        } : total.nameMap,
                    }),
                ])
            )),
            next,
        ],
    )],
    ({modules}) => {
        let exported = {};

        for (let i = 0; i < modules.modules.length; i++) {
            const m1 = modules.modules[i];

            if (!m1.feed.expo) {
                continue;
            }
            for (const expo of m1.feed.expo) {
                exported = expo(m1, exported, i);
            }
        }
        return next({
            getModule: (name) => {
                return modules.nameMap[name];
            },
            ...exported,
        });
    },
);
